import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  subscribeUserDeleted,
  clearUserDeleted,
} from "../utils/userDeletedHandler";
import { logout } from "../auth/authSlice";

const UserDeletedModal = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handlingRef = useRef(false);

  useEffect(() => {
    const unsubscribe = subscribeUserDeleted(async (msg) => {
      if (!msg || handlingRef.current) return;
      handlingRef.current = true;
      try {
        await dispatch(logout()).unwrap?.().catch(() => {});
      } catch (_) {}
      try {
        localStorage.removeItem("userData");
        localStorage.removeItem("userToken");
        localStorage.removeItem("mdm_org_user");
      } catch (_) {}
      clearUserDeleted();
      handlingRef.current = false;
      navigate("/login", { replace: true });
    });
    return unsubscribe;
  }, [dispatch, navigate]);

  return null;
};

export default UserDeletedModal;
